const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const passwordRegExp = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-zñÑ\d@$!%*#?&]{8,}$/;
const cuitRegExp = /^(20|23|24|27|30|33|34)-?([0-9]{7,8})-?([0-9])$/g;

export { phoneRegExp, passwordRegExp, cuitRegExp };
